import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import classNames from 'classnames';
import { CheckboxIcon } from '../../icons/checkbox';
import * as styles from './styles.css';
export var CheckboxView = /*#__PURE__*/function (_React$Component) {
  _inherits(CheckboxView, _React$Component);

  var _super = _createSuper(CheckboxView);

  function CheckboxView() {
    _classCallCheck(this, CheckboxView);

    return _super.apply(this, arguments);
  }

  _createClass(CheckboxView, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var mediaType = props.mediaType;
      return /*#__PURE__*/React.createElement("span", {
        className: classNames(props.className, styles.checkbox, styles.common, props.checked && styles.checked, props.disabled && styles.disabled, mediaType && styles["mediaType--".concat(mediaType)])
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.box
      }, /*#__PURE__*/React.createElement(CheckboxIcon, {
        __classNames: styles.icon,
        custom: {
          size: '84%'
        }
      })), props.label && /*#__PURE__*/React.createElement("span", {
        className: styles.label
      }, props.label));
    }
  }]);

  return CheckboxView;
}(React.Component);